import { number, object } from "superstruct";

const ReviewsProductInfoSchema = object({
    reviewsCount: number(),
    questionsCount: number(),
    averageReviewsRating: number(),
});

export default ReviewsProductInfoSchema;
